module.exports = __webpack_public_path__ + "static/media/Basal_4471.adf8cdb0.jpg";